<template>
  <div>
    <div class="header-btn">
      <el-badge :value="all_count" class="btn-item">
        <el-link @click="onLabelBtn()">全部</el-link>
      </el-badge>
      <template v-for="(item,index) in label_type_list">
        <el-badge :key="index" :value="item.num" class="btn-item">
          <el-link @click="onLabelBtn(item)">{{ item.name }}</el-link>
        </el-badge>
      </template>
    </div>

    <el-divider></el-divider>
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="HouseName"
            label="房产" width="320" fixed></el-table-column>
          <el-table-column
            prop="name"
            label="业主姓名"
            width="150" fixed>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="业主电话"
            width="180">
          </el-table-column>
          <el-table-column
            prop="butler_name"
            label="催费人员"
            width="100">
          </el-table-column>
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="type_tip"
            label="催费方式"
            width="90">
          </el-table-column>
          <el-table-column
            prop="业主诉求"
            label="业主原话"
            width="150">
          </el-table-column>
          <el-table-column
            prop="send_time"
            label="催费日期"
            width="100">
          </el-table-column>
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第一次催费时间"
            label="第一次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第二次催费时间"
            label="第二次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第三次催费时间"
            label="第三次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="添加时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="flow_status"
            label="审核状态"
            width="80">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="驳回理由"
            width="150">
          </el-table-column>
          <el-table-column
            prop="task_id"
            label="审批流程"
            width="150">
            <template slot-scope="scope">
              <el-link v-if="scope.row.task_id" type="primary" size="mini" @click="openFlow(scope.row)">查看审批</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="	操作"
            width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-view" @click="preView(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <ViewFlow ref="viewFlowRef" />
    <LegalHouseInfo ref="LegalHouseInfo" />
  </div>
</template>

<script>
import LogController from "../../../../../common/logger/LogController";
import LegalHouseInfo from "../LegalHouseInfo";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdPartyLitigationTab3",
  components: {ViewFlow, LegalHouseInfo},
  inject:['where','reginWhere'],
  data(){
    return{
      label_type_list:[
        // {type:5,name:"全 部"},
        {type:14,name:"诉讼（提交）",type_ex:5},
        {type:14,name:"诉讼（诉调）",type_ex:52},
        {type:14,name:"诉讼（立案）",type_ex:53},
        // {type:10,name:"成功催缴",type_ex:1405},
      ],
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      all_count:0,
      loading: false,
    }
  },
  mounted() {
    this.getList()
    this.getAjaxCount()
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("ThirdPartyLitigation/getList", {
        ...where,
        status: -1,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getAjaxCount(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      ButlerHttp.post("ThirdPartyLitigation/ajaxCount", {
        ...where,
        status: -1
      }, res => {
        if (res.code) {
          let label_type_list = that.label_type_list;
          label_type_list = label_type_list.map(ret => {
            let item_list = res.data.filter(r => {
              if (ret.type_ex !== undefined) {
                return ret.type == r.type && ret.type_ex == r.type_ex;
              } else {
                return ret.type == r.type;
              }
            });
            ret.num = item_list.reduce((prev, cur) => prev + cur.count, 0);
            return ret;
          });
          that.label_type_list = label_type_list;
          that.type_list = res.data;
          that.all_count = res.data.reduce((p, n) => p + n.count, 0);
        }
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    onLabelBtn(item=null){
      this.where.type=(item||{}).type||"";
      this.where.type_ex=(item||{}).type_ex||"";
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
    },
    preView(item){
      this.$refs.LegalHouseInfo.show(item)
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "reginWhere.area_id":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "reginWhere.age":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "where.text":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "where.start_time":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    },
    "where.end_time":function (n,o) {
      this.pageChange(1)
      this.getAjaxCount()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationTab3.vue